module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-nl.e93360b401f94ff21424.svg";